import type { AuthSession } from '@/auth/types';

type ResolveProjectManagementAccessInput = {
  session: AuthSession | null;
  projectOrganisationId: string | null;
  projectCreatedById: string | null;
  isOrganisationAdmin: boolean;
  isOrganisationRoleLoading: boolean;
};

export type ProjectManagementAccess = {
  canManageProject: boolean;
  canManageProjectLoading: boolean;
  isProjectOwner: boolean;
};

export const resolveProjectManagementAccess = ({
  session,
  projectOrganisationId,
  projectCreatedById,
  isOrganisationAdmin,
  isOrganisationRoleLoading,
}: ResolveProjectManagementAccessInput): ProjectManagementAccess => {
  const isPersonalProject = projectOrganisationId === null;
  const isProjectOwner =
    isPersonalProject &&
    typeof projectCreatedById === 'string' &&
    projectCreatedById === session?.userId;

  return {
    canManageProject: Boolean(session) && (isOrganisationAdmin || isProjectOwner),
    canManageProjectLoading: Boolean(session) && isOrganisationRoleLoading && !isProjectOwner,
    isProjectOwner,
  };
};
